export function isValidImg(file) {

    if (!file) {
        return false
    }

    if (!file.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        return false
    }

    const img = new Image()
    img.onerror = () => {
        return false
    }

    if (file.size > 8 * 1024 * 1024) { // 8MB in bytes
        return false
    }

    return true
}

export function isImg(image) {
    return new Promise((resolve) => {
        const fileReader = new FileReader();
        fileReader.onloadend = () => {
            // Verificamos si el tipo de archivo es una imagen
            if (fileReader.result && fileReader.result.startsWith("data:image")) {
                resolve(true);
            } else {
                resolve(false);
            }
        };
        fileReader.readAsDataURL(image);
    });
};

export function isValidWebp(blob) {
    return blob.type === 'image/webp'
}